import { page as pageIndex } from '../../globals'
import {
  matchParameters,
  filterRegions,
  sortAlphabetical,
  returnDateFormat,
  sortFieldList,
  mapGroupNotesOptionsValues,
  returnTextValuesForClearedFilters,
  mapGroupNotesFieldList } from './helpers'
import {
  START_DATA_FETCH,
  DATA_FETCHED,
  FETCH_FAILED,
  SAVE_GROUP_NOTES_OPTIONS,
  RETURN_DEFAULT_REPORT,
  OPEN_SAVED_REPORT,
  getFormDataHandlers,
  actionGroupNoteHandler } from './getFormData'
import { UPDATE_DATA, actionHandler } from './updateData'
import { CLEAR_FILTERS, NEW_REPORT_SAVED } from './reportLine'
// ------------------------------------
// Actions
// ------------------------------------
function transformBillTypes (arr) {
  let typeCodes = []
  const transformedArr = arr.map(item => {
    if (!typeCodes.includes(item.TypeCode)) {
      typeCodes = [...typeCodes, item.TypeCode]
      return {
        text: item.TypeCode,
        id: item.TypeCode,
        type: 'checkbox-with-descr',
        description: item.Description,
        childrenStyles: {
          display: 'inline-block',
          width: 100,
        },
        descriptionStyles: {
          fontWeight: 300, maxWidth: 183, display: 'inline-block', verticalAlign: 'top', lineHeight: '24px'
        }
      }
    } else return false
  }).filter(item => item !== false)
  return sortAlphabetical(transformedArr, 'text')
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [START_DATA_FETCH] : getFormDataHandlers['START_DATA_FETCH'],
  [FETCH_FAILED] : getFormDataHandlers['FETCH_FAILED'],
  [DATA_FETCHED] : (state, action) => {
    const { page, field } = action.location
    const { json } = action.payload
    const mappedApiData = mapGroupNotesFieldList(json.FieldList)
    if (page !== pageIndex.legis) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        [page]: {
          ...state.renderData[page],
          [field]: {
            archiveStartYear: json.ArchiveStartYear,
            billTypes: {
              billTypeBlock: transformBillTypes(json.BillTypes),
              stateGuide: sortAlphabetical(json.BillTypes, 'RegionName')
            },
            clientId: json.ClientId,
            defaultReport: json.DefaultReport,
            favoritesList: json.FavoritesList,
            fieldList: sortFieldList(json.FieldList),
            fieldOptions: mapGroupNotesOptionsValues(json.FieldOptions),
            prefileOptionsList: json.PrefileOptionsList,
            regionList: filterRegions(json.RegionList),
            subjectList: json.SubjectList,
            userId: json.UserId
          }
        }
      },
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...state.formDataValue[page],
          [field]: {
            ...state.formDataValue[page][field],
            radio: {
              ...state.formDataValue[page][field].radio,
              ...mappedApiData.radio,
            },
            dateTime: {
              ...state.formDataValue[page][field].dateTime,
              ...mappedApiData.dateTime,
            },
            textValues: {
              ...state.formDataValue[page][field].textValues,
              ...mappedApiData.textValues
            }
          }
        }
      }
    }
  },
  [SAVE_GROUP_NOTES_OPTIONS] : (state, action) => action.location.page !== pageIndex.legis
    ? state : actionGroupNoteHandler(state, action),
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.legis ? state : actionHandler(state, action),
  [CLEAR_FILTERS] : (state, action) => {
    const { page } = action
    if (page !== pageIndex.legis) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...clearState.formDataValue[page],
          groupNotes: {
            ...clearState.formDataValue[page].groupNotes,
            textValues: returnTextValuesForClearedFilters
          }
        }
      }
    }
  },
  [RETURN_DEFAULT_REPORT] : (state, action) => {
    const { page } = action
    if (page !== pageIndex.legis) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...initialState.formDataValue[page],
          groupNotesOptions: {
            selected: [
              ...state.formDataValue[page].groupNotesOptions.selected
            ],
            radio: {
              sw0h: false
            }
          }
        }
      },
      renderData: {
        ...state.renderData
      }
    }
  },
  [OPEN_SAVED_REPORT] : (state, action) => {
    const { page } = action
    const { json } = action.payload
    if (page !== pageIndex.legis || json === undefined) {
      return {
        ...state,
      }
    } else {
      const criteria = matchParameters(json.ReportCriteria, state.renderData[page].groupNotes.fieldList)
      let favorites = criteria.filters.personalreport ? criteria.filters.personalreport : []
      favorites = criteria.filters.notinpersonalreport ? [...favorites, 'notinpersonalreport'] : favorites
      return {
        ...state,
        isFetchingData: false,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...state.formDataValue[page],
            defaultSearch: {
              ...state.formDataValue[page].defaultSearch,
              title: json.Name,
              textValues: {
                ...state.formDataValue[page].defaultSearch.textValues,
                reporttitle: criteria.filters.reporttitle || '',
                billnumbers: criteria.filters.billnumbers || ''
              },
              dateTime: {
                recorddatestart: criteria.filters.recorddatestart
                  ? returnDateFormat(criteria.filters.recorddatestart[0])
                  : new Date(new Date().getFullYear(), 0, 1),
                recorddateend: criteria.filters.recorddateend
                  ? returnDateFormat(criteria.filters.recorddateend[0])
                  : new Date(),
                hearingdatestart: ' ',
                hearingdateend: ' ',
              },
              radio: {
                reporttype: criteria.filters.reporttype[0] || 'alltracked',
              },
            },
            viewingOptions: {
              selected: criteria.viewingOptions.selected || [],
              radio: {
                histlist: criteria.viewingOptions.historyRadioButton,
                howmany: criteria.viewingOptions.howmany,
              },
            },
            advancedEditingTools: {
              selected: criteria.advancedEditingTools.selected || [],
              radio: {
                sortheader: !!criteria.advancedEditingTools.sortheader,
                sort1: criteria.advancedEditingTools.sort1[0],
                sort2: criteria.advancedEditingTools.sort2[0],
                sort3: criteria.advancedEditingTools.sort3[0],
                sort4: criteria.advancedEditingTools.sort4[0],
              }
            },
            reportFormat: {
              selected: criteria.mapOptions.selectedAdvancedOptions
                ? criteria.mapOptions.selectedAdvancedOptions : [],
              radio: {
                mapit: !!criteria.mapOptions.mapit,
                outformat: criteria.mapOptions.outformat,
              }
            },
            maps: {
              selected: criteria.mapOptions.selected !== undefined ? criteria.mapOptions.selected : [],
              textValues: {
                lowcountcolor: criteria.mapOptions.lowcountcolor ||
                  state.formDataValue[page].maps.textValues.lowcountcolor,
                medcountcolor: criteria.mapOptions.medcountcolor ||
                  state.formDataValue[page].maps.textValues.medcountcolor,
                highcountcolor: criteria.mapOptions.highcountcolor ||
                  state.formDataValue[page].maps.textValues.highcountcolor,
                foundbillscolor: criteria.mapOptions.foundbillscolor ||
                  state.formDataValue[page].maps.textValues.foundbillscolor,
              },
            },
            groupNotesOptions: {
              selected: criteria.groupNotesOptions ? criteria.groupNotesOptions : [],
              radio: {
                sw0h: false,
              }
            },
            additionalFilters: {
              textValues: {
                summary: criteria.filters.summary ? criteria.filters.summary : '',
                sponsor: criteria.filters.sponsor ? criteria.filters.sponsor : '',
                history: criteria.filters.history ? criteria.filters.history : '',
                personalnotes: criteria.filters.personalnotes ? criteria.filters.personalnotes : ''
              },
              dateTime: {
                introdatestart: criteria.filters.introdatestart
                  ? returnDateFormat(criteria.filters.introdatestart[0]) : ' ',
                introdateend: criteria.filters.introdateend
                  ? returnDateFormat(criteria.filters.introdateend[0]) : ' ',
                actiondatestart: criteria.filters.introdateend
                  ? returnDateFormat(criteria.filters.actiondatestart[0]) : ' ',
                actiondateend: criteria.filters.actiondateend
                  ? returnDateFormat(criteria.filters.actiondateend[0]) : ' ',
                personalnotesstart: criteria.filters.personalnotesstart
                  ? returnDateFormat(criteria.filters.personalnotesstart[0]) : ' ',
                personalnotesend: criteria.filters.personalnotesend
                  ? returnDateFormat(criteria.filters.personalnotesend[0]) : ' ',
              }
            },
            archivedYear: {
              selected: criteria.filters.archive ? criteria.filters.archive : ['current'],
            },
            archivedSubjects: {
              selected: criteria.filters.archivedsubjects ? criteria.filters.archivedsubjects : [],
            },
            billType: {
              selected: criteria.filters.billtype ? criteria.filters.billtype : [],
            },
            carryOrders: {
              selected: criteria.filters.carry ? criteria.filters.carry : ['any'],
            },
            groupNotes: {
              selected: criteria.groupNotesFilters ? criteria.groupNotesFilters.selected : [],
              radio: {
                noteslogic: criteria.filters.noteslogic === 'and' || criteria.filters.noteslogic === undefined
                ? 'ALL selected Group Notes criteria must be true.'
                : 'ANY selected Group Notes criteria must be true.'
              },
              dateTime: {
                noteslastupdatestart: criteria.filters.noteslastupdatestart
                  ? returnDateFormat(criteria.filters.noteslastupdatestart[0]) : ' ',
                noteslastupdateend: criteria.filters.noteslastupdateend
                  ? returnDateFormat(criteria.filters.noteslastupdateend[0]) : ' ',
              },
              textValues: criteria.groupNotesFilters.textValues
            },
            favorites: {
              selected: favorites
            },
            progress: {
              selected: criteria.filters.progress ? criteria.filters.progress : []
            },
            subjects: {
              selected: criteria.filters.subjects ? criteria.filters.subjects : []
            },
            states: {
              selected: criteria.filters.states ? criteria.filters.states : []
            }
          }
        },
        renderData: {
          ...state.renderData,
          [page]: {
            ...state.renderData[page],
            groupNotes: {
              ...state.renderData[page].groupNotes,
              selectedReport: json,
            }
          }
        }
      }
    }
  },
  [NEW_REPORT_SAVED] : (state, action) => {
    const { json, name } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        L: {
          ...state.renderData.L,
          saveReportId: json,
          duplicatedReportName: false,
        }
      },
      formDataValue: {
        ...state.formDataValue,
        L: {
          ...state.formDataValue.L,
          defaultSearch: {
            ...state.formDataValue.L.defaultSearch,
            title: name,
          }
        }
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const clearState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    L: {
      groupNotes: {},
    },
  },
  formDataValue: {
    L: {
      viewingOptions: {
        selected: [],
        radio: {
          histlist: 'History by Line',
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: '',
          billnumbers: '',
        },
        radio: {
          reporttype: 'alltracked',
        },
        dateTime: {
          recorddatestart: new Date(new Date().getFullYear(), 0, 1),
          recorddateend: new Date(),
          hearingdatestart: ' ',
          hearingdateend: ' ',
        }
      },
      groupNotes: {
        selected: [],
        radio: {
          noteslogic: 'ALL selected Group Notes criteria must be true.',
        },
        dateTime: {
          noteslastupdatestart: ' ',
          noteslastupdateend: ' ',
        },
      },
      groupNotesOptions: {
        selected: [],
        radio: {
          sw0h: false,
        }
      },
      additionalFilters: {
        textValues: {
          summary: '',
          sponsor: '',
          history: '',
          personalnotes: ''
        },
        dateTime: {
          introdatestart: ' ',
          introdateend: ' ',
          actiondatestart: ' ',
          actiondateend: ' ',
          personalnotesstart: ' ',
          personalnotesend: ' ',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'state',
          sort2: 'billtype',
          sort3: 'billnumber',
          sort4: 'session',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      billType: {
        selected: [],
      },
      carryOrders: {
        selected: ['any'],
      },
      archivedYear: {
        selected: ['current'],
      },
      archivedSubjects: {
        selected: [],
      },
      subjects: {
        selected: [],
      },
      favorites: {
        selected: [],
      },
      states: {
        selected: [],
      },
      progress: {
        selected: [],
      },
      priority: {
        selected: [],
      },
      position: {
        selected: [],
      },
      revenue: {
        selected: [],
      },
      compliance: {
        selected: [],
      },
      department: {
        selected: [],
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
    },
  },
}
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    L: {
      groupNotes: {},
    },
  },
  formDataValue: {
    L: {
      viewingOptions: {
        selected: [
          'viewsearchcriteria', 'viewsession', 'viewintrodate',
          'viewprogress', 'viewemailalerts', 'viewemailit',
          'viewsponsor', 'viewotherlinks', 'viewsubject',
          'viewsummary', 'viewhearings', 'viewhistory', '',
          'viewpersonalnotes', 'viewpersreports', 'viewlegisstatebackdrop'
        ],
        radio: {
          histlist: 'History by Line',
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: 'Legislative Report',
          billnumbers: '',
        },
        radio: {
          reporttype: 'alltracked',
        },
        dateTime: {
          recorddatestart: new Date(new Date().getFullYear(), 0, 1),
          recorddateend: new Date(),
          hearingdatestart: ' ',
          hearingdateend: ' ',
        }
      },
      groupNotes: {
        selected: [],
        radio: {
          noteslogic: 'ALL selected Group Notes criteria must be true.',
        },
        dateTime: {
          noteslastupdatestart: ' ',
          noteslastupdateend: ' ',
        },
      },
      groupNotesOptions: {
        selected: ['editnotes', 'viewnoteslastupdated'],
        radio: {
          sw0h: false,
        }
      },
      additionalFilters: {
        textValues: {
          summary: '',
          sponsor: '',
          history: '',
          personalnotes: ''
        },
        dateTime: {
          introdatestart: ' ',
          introdateend: ' ',
          actiondatestart: ' ',
          actiondateend: ' ',
          personalnotesstart: ' ',
          personalnotesend: ' ',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'state',
          sort2: 'billtype',
          sort3: 'billnumber',
          sort4: 'session',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      billType: {
        selected: [],
      },
      carryOrders: {
        selected: ['any'],
      },
      archivedYear: {
        selected: ['current'],
      },
      archivedSubjects: {
        selected: [],
      },
      subjects: {
        selected: [],
      },
      favorites: {
        selected: [],
      },
      states: {
        selected: [],
      },
      progress: {
        selected: [],
      },
      priority: {
        selected: [],
      },
      position: {
        selected: [],
      },
      revenue: {
        selected: [],
      },
      compliance: {
        selected: [],
      },
      department: {
        selected: [],
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
    },
    Bill: {
      favorites: {
        selected: [],
      },
    },
  },
}
export default function legisDataReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/legisFormData.js